import Vue from 'vue';
import App from './App.vue';
import '@/assets/css/tailwind.css';
import router from './router';
import VueMeta from 'vue-meta'; 
import store from './store';
import axios from 'axios';
import "vue-easytable/libs/theme-default/index.css";
import VueEasytable, { VeLocale } from "vue-easytable";
import enUS from "vue-easytable/libs/locale/lang/en-US";
import IdleVue from 'idle-vue';
const eventsHub = new Vue()

Vue.config.productionTip = false;
axios.defaults.baseURL = 'https://api.lipalink.com/api/v1/';

Vue.use(VueEasytable);
// Force English locale so table/pagination text (e.g. the page-size dropdown)
// isn't rendered in the library's default Chinese (请选择).
VeLocale.use(enUS);
Vue.use(VueMeta);
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 300000
})


// Cancel Token Request Interceptor
axios.interceptors.request.use(function (config) {
  
  //  Generate cancel token source
  let source = axios.CancelToken.source();

  // Set cancel token on this request
  config.cancelToken = source.token;

  // Add to vuex to make cancellation available from anywhere
  store.commit('addCancelTokens', source);

  // Attach access token from store for authenticated requests (e.g. change-password, organization, etc.)
  const token = store.getters.getToken;
  const isPublicPath = /^(auth\/login|auth\/register|account\/[^/]+\/(forgot-password|reset-password))(\/|$)/i.test(config.url || '');
  if (token && !config.headers['Authorization'] && !isPublicPath) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
}, function (error) {
  return Promise.reject(error);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
